var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm._t("header"),
      _vm._v(" "),
      _vm.paginate.last_page > 1 && !_vm.$slots.header
        ? _c(
            "div",
            {
              staticClass: "d-flex align-items-end justify-content-end",
              attrs: { id: "paginate-" + _vm.id_table },
            },
            [
              _c("paginate", {
                attrs: { id_paginate: _vm.id_table },
                on: {
                  buscarPagina: function ($event) {
                    return _vm.pagina($event)
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "position-relative" },
        [
          _c(
            "table",
            {
              staticClass:
                "table table-sm table-responsive-sm table-hover mb-0 text-wrap",
              attrs: { id: _vm.id_table },
            },
            [
              _c("thead", [_c("tr", [_vm._t("thead")], 2)]),
              _vm._v(" "),
              _c(
                "tbody",
                _vm._l(_vm.listaRegistros, function (registro, row) {
                  return _c(
                    "tr",
                    {
                      key: "row-" + _vm.id_table + "-" + row,
                      attrs: { id: _vm.id_table + "-" + row },
                    },
                    [
                      _vm._t("body", null, null, {
                        index: row,
                        data: registro,
                        paginate: _vm.expo_paginate,
                      }),
                    ],
                    2
                  )
                }),
                0
              ),
            ]
          ),
          _vm._v(" "),
          _vm.$slots.empty_rows
            ? _c(
                "div",
                {
                  staticClass: "col-12 px-0 d-none my-2",
                  attrs: { id: "alert_table-" + _vm.id_table },
                },
                [_vm._t("empty_rows")],
                2
              )
            : _c(
                "div",
                {
                  staticClass: "alert alert-warning col-12 d-none my-2",
                  attrs: { id: "alert_table-" + _vm.id_table, role: "alert" },
                },
                [
                  _vm._v(
                    "\n            Nenhum registro encontrado!\n\n            "
                  ),
                  _vm._t("alert_table"),
                ],
                2
              ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "alert alert-info col-12 d-none my-2",
              attrs: { id: "alert_validate-" + _vm.id_table, role: "alert" },
            },
            [
              _vm._v(
                "\n            Utilize o campo de busca e/ou os filtros para encontrar os registros!\n        "
              ),
            ]
          ),
          _vm._v(" "),
          _c("div", { attrs: { id: "paginate-" + _vm.id_table + "-2" } }, [
            _c(
              "div",
              { staticClass: "float-right pt-2" },
              [
                _c("paginate", {
                  attrs: { id_paginate: _vm.id_table + "-2" },
                  on: {
                    buscarPagina: function ($event) {
                      return _vm.pagina($event)
                    },
                  },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("hr", { staticClass: "mt-0" }),
          _vm._v(" "),
          _c("transition", { attrs: { name: "fade" } }, [
            _vm.carregando
              ? _c(
                  "div",
                  {
                    staticClass:
                      "p-3 text-center position-absolute col-12 d-flex align-items-center justify-content-center",
                    staticStyle: {
                      top: "24px",
                      "background-color": "rgba(255,255,255,0.5)",
                      height: "calc(100% - 24px)",
                    },
                  },
                  [
                    _c("hollow-dots-spinner", {
                      attrs: {
                        "animation-duration": 1000,
                        "dot-size": 10,
                        "dots-num": 3,
                        color: "#6F787D",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }